// async function login_In_button() {
//     await ethereum.request({ method: 'eth_requestAccounts' });
//     window.location.reload();
// }

async function signWalletConnect() {
    try {
        var jsonStr = await signMetaMask();
        var unity = await window.getUnityInstance();
        unity.SendMessage('GameManager', 'CheckWalletConnectSignature', jsonStr);
        return jsonStr;
    } catch (e) {
        console.error(e);
        var unity = await window.getUnityInstance();
        unity.SendMessage('GameManager', 'ConnectWalletCancel');
        return null;
    }
}

async function getMKP() {
    var balance = 0;
    try {
        balance = await getMkpBalance();
        // console.log('balance = ' + balance);
    } catch (e) {
        balance = 0;
        console.error(e);
    }
    var unity = await window.getUnityInstance();
    unity.SendMessage('ChainManager', 'UpdateMKPBalance', balance);
}

/**
 * 根據指定的數量 Mint 英雄
 * @param {number} amount 
 */
async function MintHero(amount) {
    try {
        const montNFT = await MetaNFT.methods.mintHero(amount).send({ from: coinbase, value: 0, gas: 150000 });
        // console.log(montNFT);
    } catch (e) {
        console.error(e);
    }
    unity.SendMessage('ChainManager', 'OnHeroMint');
}

// async function CheckOwner(jsonStr) {
//     var jsonObj = JSON.parse(jsonStr);
//     var isOwner = true;
//     try {
//         for (let i = 0; i < jsonObj.length; i++) {
//             let addr = await MetaNFT.methods.ownerOf(jsonObj[i]['id']).call();
//             if(addr != jsonStr['address'])isOwner = false;
//         }
//     } catch (e) {
//         isOwner = false;
//     }

//     unity.SendMessage('ChainManager', 'OnCheckOwner', isOwner.toString());
// }

async function GetPlayerNFT(tempName) {
    const heroIds = [];
    const barIds = [];
    const partnerIds = [];

    const heroSale = [];
    const monstersale = [];
    const barSale = [];

    await Promise.all([
        MetaNFT.methods.HeroSale().call(),
        MetaNFT.methods.monstersale().call(),
        MetaNFT.methods.BarSale().call()
    ]).then(value => {
        for (let i = 10001; i <= value[0]; i++) {//Token id 9000 後都是英雄
            heroSale.push(i);
        }
        for (let i = 6001; i <= value[1]; i++) {//Token id 6000 ~ 8999都是魔物夥伴
            monstersale.push(i);
        }
        for (let i = 1; i <= value[2]; i++) {//Token id 1 ~ 5999 都是酒吧
            barSale.push(i);
        }
    });

    const a = heroSale.map(async (value) => {
        let addr = await MetaNFT.methods.ownerOf(value).call();
        if (addr.toLowerCase() == coinbase.toLowerCase()) {
            heroIds.push(value);
        }
    });
    const b = monstersale.map(async (value) => {
        let addr = await MetaNFT.methods.ownerOf(value).call();
        if (addr.toLowerCase() == coinbase.toLowerCase()) {
            partnerIds.push(value);
        }
    });
    const c = barSale.map(async (value) => {
        let addr = await MetaNFT.methods.ownerOf(value).call();
        if (addr.toLowerCase() == coinbase.toLowerCase()) {
            barIds.push(value);
        }
    });

    await Promise.all([...a, ...b, ...c]);

    var jsonObj = { Hero: heroIds, Partner: partnerIds, Bar: barIds };

    var jsonStr = JSON.stringify(jsonObj);

    // console.log(`jsonStr = ${jsonStr}`);

    unity.SendMessage(tempName, 'GetPlayerNFT', jsonStr);
}


/**
 * 根據地址中可以被提領的英雄數量，計算Gas並且提領，這邊提領的是透過Mint得到的英雄
 */
async function ClaimHero(amount) {
    let confrim = true;
    try {
        let setGas = await MetaNFT.methods.HeroAmount(coinbase).call();
        // console.log(`Claim ${amount} Hero`);
        await MetaNFT.methods.ClaimHero(amount.toString()).send({ from: coinbase })
            .then(function (value) {
                // console.log(value.cumulativeGasUsed);
            });
    } catch (e) {
        confrim = false;
        console.error(e);
    }

    unity.SendMessage('ChainManager', 'OnHeroClaim', confrim ? 'true' : 'false');
}
/**
 * 取得可以被提領的英雄數量，這邊的是透過Mint得到的數量
 */
async function GetClaimHeroAmount() {
    let amount = 0;
    try {
        amount = await MetaNFT.methods.HeroAmount(coinbase).call();
    } catch (e) {
        console.error(e);
        amount = 0;
    }
    var unity = await window.getUnityInstance();
    unity.SendMessage('ChainManager', 'UpdateHeroUnclaimAmount', amount.toString());
}

/**
 * 依據指定的數量 Mint 魔物夥伴
 * @param {number} amount 
 */
async function MintPartner(amount) {
    try {
        let MonsterSalePrice = await MetaNFT.methods.MonsterPartnerPrice().call();
        await MetaNFT.methods.mintMonster(amount).send({ from: coinbase, value: MonsterSalePrice * amount, gas: 60000 })
            .then("data", function (data) {
                // console.log(data);
            })
    } catch (e) {
        console.error(e);
    }

    unity.SendMessage('ChainManager', 'OnPartnerMint');
}
/**
 * 根據地址中可以被提領的夥伴數量，計算Gas並且提領，這邊提領的是透過Mint得到的英雄
 */
async function ClaimPartner(amount) {
    let confrim = true;
    try {
        let monstetgs = await MetaNFT.methods.MonsterAmount(coinbase).call();
        // console.log(`Claim ${amount} Partner`);

        await MetaNFT.methods.ClaimMonster(amount.toString()).send({ from: coinbase });
    } catch (e) {
        confrim = false;
        console.error(e);
    }
    unity.SendMessage('ChainManager', 'OnPartnerClaim', confrim ? 'true' : 'false');
}

async function GetClaimPartnerAmount() {
    let amount = 0;
    try {
        amount = await MetaNFT.methods.MonsterAmount(coinbase).call();
        // console.log('這邊應該改成 Partner');
    } catch (e) {
        console.error(e);
    }

    var unity = await window.getUnityInstance();
    unity.SendMessage('ChainManager', 'UpdatePartnerUnclaimAmount', amount.toString());
}


async function setCollent() {
    // let account = await ethereum.request({ method: 'eth_requestAccounts' });
    // coinbase = account[0];
    let JSONStr = await signWalletConnect();
    if (JSONStr == null) return;
    let account = JSON.parse(JSONStr);
    coinbase = account['address'];

    let ETHbalance = await web3.eth.getBalance(coinbase);
    ETHbalance = web3.utils.fromWei(ETHbalance, 'ether');

    let add = coinbase.substring(0, 12)
    add = add + "....";

    // console.log(add);

    // $("#unity-build-title").text(coinbase);

    // $("#tes").text(add);

    // $("#Addr").text(coinbase);

}
/**
 * 購買酒吧
 * @param {number} lv 
 */
async function BuyBar(lv) {
    try {
        await MetaNFT.methods.BuyBar(lv).send({ from: coinbase, value: 0, gas: 250000 })
            .then(
                console.log("finish")
            );
    } catch (e) {
        console.error(e);
    }

    var unity = await window.getUnityInstance();
    unity.SendMessage('ChainManager', 'OnBarBuy');
}

/**
 * 獲取當前酒吧的供應數量
 */
async function GetBarSupply() {
    var jsonObj = await Promise.all([
        GetBarInfo(0),
        GetBarInfo(1),
        GetBarInfo(2),
        GetBarInfo(3),
        GetBarInfo(4),
        GetBarInfo(5),
    ]);

    var unity = await window.getUnityInstance();
    var jsonStr = JSON.stringify(jsonObj);
    unity.SendMessage('ChainManager', 'OnBarSupply', jsonStr);
}

async function GetBarInfo(lv) {
    let num = -1;
    switch (lv) {
        case 0:
            return { lv: lv, maxAmount: 0, currentAmount: num, price: -1 };
        case 1:
            num = await MetaNFT.methods.barRemain(1).call();
            return { lv: lv, maxAmount: 4000, currentAmount: num, price: .3500 };//bnb
        case 2:
            num = await MetaNFT.methods.barRemain(2).call();
            return { lv: lv, maxAmount: 1700, currentAmount: num, price: .6000 };
        case 3:
            num = await MetaNFT.methods.barRemain(3).call();
            return { lv: lv, maxAmount: 200, currentAmount: num, price: .9000 };
        case 4:
            num = await MetaNFT.methods.barRemain(4).call();
            return { lv: lv, maxAmount: 70, currentAmount: num, price: 1.2500 };
        case 5:
            num = await MetaNFT.methods.barRemain(5).call();
            return { lv: lv, maxAmount: 30, currentAmount: num, price: 1.6500 };
    }
}

/**
 * 開啟玩家的招募令
 * @param {string} jsonStr 數量&等級
 */
async function openRecruitment(jsonStr) {
    let json = JSON.parse(jsonStr);
    let amount = json['amount'];
    let lv = json['lv'];

    try {
        await MetaNFT.methods.INO_WithDraw(lv).send({ from: coinbase });
        unity.SendMessage('ChainManager', 'OnRecruitmentOpened');
    } catch (e) {
        console.error(e);
        unity.SendMessage('ChainManager', 'OnRecruitmentCanceled');
    }
}

/**
 * 取得所有招募令的陣列
 * @param {string} jsonStr 
 */
async function getRecruitmentArray(jsonStr) {
    let json = JSON.parse(jsonStr);
    let lv = json['lv'];
    let tempName = json['tempName'];
    try {
        let araeArray = await MetaNFT.methods.View_INO_Sale(lv).call();
        let json = JSON.stringify({ rarity: lv, amount: araeArray });
        console.log(araeArray + ' _ ' + json);

        unity.SendMessage(tempName, 'OnReceive', json);
    } catch (e) {
        unity.SendMessage(tempName, 'OnCancel');
    }

}

async function getRecruitmentAmount(jsonStr) {
    let json = JSON.parse(jsonStr);
    let lv = json['lv'];
    let tempName = json['tempName'];
    try {
        let amount = await MetaNFT.methods.INOHero(coinbase, lv).call();
        // console.log(`lv ${lv} amount = ${amount}`);
        unity.SendMessage(tempName, 'OnReceive', parseInt(amount));
    } catch (e) {
        unity.SendMessage(tempName, 'OnCancel');
    }

}

/**
 * 目前各等級酒吧還剩下幾間
 */
async function barRemain() {
    //barRemain
    let remain = [];
    for (let a = 1; a < 6; a++) {
        let num = await MetaNFT.methods.barRemain(a).call();
        remain.push(num);
    }
    // console.log(remain);
}

async function AskForMKPPremission(JSONStr) {
    let jsonObj = JSON.parse(JSONStr);
    let content = jsonObj['signContent'];
    let tempName = jsonObj['tempName'];
    var unity = await window.getUnityInstance();
    try {
        var jsonStr = await signMetaMask(content);
        unity.SendMessage(tempName, 'Success', jsonStr);
    } catch (e) {
        unity.SendMessage(tempName, 'Cancel');
        console.error(e);
    }
}


// setCollent();
let MetaMkpContract = "0x2fF66857a5da2327aa8912BBd4a1433F8F95a4b0";
let MetaNFTContract = "0x45c77d2843111dAb5Ba41C26946882A129Ec21a5";
let MarketContract = "0x92c3B00fb6A132C1dEbE9Ede7bEBcc123A59A9f1";

// let BUSD_Contract = "0x78867BbEeF44f2326bF8DDd1941a4439382EF2A7";//BSC testnet 

let MKP;
let MetaNFT;
let Market;

async function setNFT_ABI() {
    MKP = new web3.eth.Contract(MKP_ABI, MetaMkpContract);
    MetaNFT = new web3.eth.Contract(NFT_ABI, MetaNFTContract);
    Market = new web3.eth.Contract(Market_ABI, MarketContract);
}

async function getMkpBalance() {//確認MKP數量

    let mkpbalance = await MKP.methods.balanceOf(coinbase).call();
    // $("#MKPB").text(web3.utils.fromWei(mkpbalance, 'ether') + " MKP ");
    // console.log(web3.utils.fromWei(mkpbalance, 'ether'));
    return web3.utils.fromWei(mkpbalance, 'ether');
}

async function askForGas(jsonStr) {//向玩家請求 GasFee
    let obj = JSON.parse(jsonStr);
    let tempName = obj['tempName'];
    let addr = obj['address'];

    let inputvalue = '0.001';
    try {
        await MetaNFT.methods.payToWithDraw(addr.toString()).send({ from: coinbase, value: web3.utils.toWei(inputvalue, 'ether') });
        unity.SendMessage(tempName, 'Success');
    } catch (e) {
        console.error(e);
        unity.SendMessage(tempName, 'Cancel');
    }
}

/**
 * 檢查質押等級
 */
async function Check_Stake_Level(tempName) {
    if (coinbase == null || MKP == null) {
        unity.SendMessage(tempName, 'OnGetStakeLevel', 0);
        return;
    }

    try {
        let StakeInfo = await MKP.methods.StakingValue(coinbase).call();
        //Web3.utils.toWei('1', 'ether');
        StakeInfo = parseInt(Web3.utils.fromWei(StakeInfo, 'ether'));

        // console.log("Your stake value:" + StakeInfo);

        unity.SendMessage(tempName, 'OnGetStakeLevel', StakeInfo);
        // $("#stakeMKP").text("MKP staked :" + StakeInfo);
    } catch (e) {
        console.error("ERROR : " + e);
        unity.SendMessage(tempName, 'OnGetStakeLevel', 0);
    }

}



// let heroArray = [];

// async function getHeroBalance(){
//     const t0 = performance.now();
//     let heroSale = await MetaNFT.methods.HeroSale().call();

//      for(let num = 5001;num<=heroSale;num++){
//         let Hero_user = await MetaNFT.methods.ownerOf(num).call();

//         if(Hero_user.toLowerCase() == coinbase){
//             heroArray.push(num);
//         }
//     }
//     const t1 = performance.now();

//     console.log("Hero you own :"+ heroArray);
//     console.log(t1 - t0);
// }

async function getHeroBalance2() {//取得英雄數量陣列

    let array2 = [];
    let hes = [];
    let heroSale = await MetaNFT.methods.HeroSale().call();

    for (let num = 10001; num <= heroSale; num++) {
        array2.push(num);
    }

    const heroArrays = await Promise.all(array2.map(
        async function (value) {
            let addr = await MetaNFT.methods.ownerOf(value).call();
            if (addr.toLowerCase() == coinbase) {
                hes.push(value);
            }
        })
    );

    hes.sort();

    // console.log("Hero you own :" + hes);
    return hes;
}

async function get_BarBalance() {//取得酒吧數量陣列

    let array2 = [];
    let hes = [];
    let BarSale = await MetaNFT.methods.BarSale().call();

    for (let num = 1; num <= BarSale; num++) {
        array2.push(num);
    }

    const heroArrays = await Promise.all(array2.map(
        async function (value) {
            let addr = await MetaNFT.methods.ownerOf(value).call();
            if (addr.toLowerCase() == coinbase) {
                hes.push(value);
            }
        })
    );

    hes.sort();

    // console.log("BAR you own :" + hes);

    return hes;
}

/**
 * 該玩家擁有那些等級的酒吧
 */
async function BarOwn() {
    let barow = [];
    for (let a = 1; a < 6; a++) {
        let num = await MetaNFT.methods.barOwned(coinbase, a).call();
        barow.push(num);
    }
    // console.log(`barow : ${barow}`);
}



async function get_PartnerBalance() {//取得英雄數量陣列

    let array2 = [];
    let hes = [];
    let BarSale = await MetaNFT.methods.monstersale().call();

    for (let num = 6001; num <= BarSale; num++) {
        array2.push(num);
    }

    const heroArrays = await Promise.all(array2.map(
        async function (value) {
            let addr = await MetaNFT.methods.ownerOf(value).call();
            if (addr.toLowerCase() == coinbase) {
                hes.push(value);
            } else {

            }
        })
    );
    hes.sort();
    // console.log("Monster Partner you own :" + hes);

    return hes;
}

const networks = {
    /** @type {ChainNetwork} */
    bsc_testnet: {
        chainId: '0x61',
        chainName: 'Binance Smart Chain Testnet',
        rpcUrls: ['https://data-seed-prebsc-1-s1.binance.org:8545'],
        blockExplorerUrls: ['https://testnet.bscscan.com'],
        nativeCurrency: { symbol: 'tBNB', decimals: 18 }
    },

    /** @type {ChainNetwork} */
    bsc_mainnet: {
        chainId: '0x38',
        chainName: 'Binance Smart Chain Mainnet',
        rpcUrls: ['https://bsc-dataseed1.binance.org'],
        blockExplorerUrls: ['https://bscscan.com'],
        nativeCurrency: { symbol: 'BNB', decimals: 18 }
    },
}

/**
 * @typedef {Object} ChainNetwork
 * @property {string} chainId 
 * @property {string} chainName 
 * @property {string[]} rpcUrls 
 * @property {string[]} blockExplorerUrls 
 * @property {{symbol: string, decimals:number}} blockExplorerUrls 
 */

/**
 * @param {ChainNetwork} network // A 0x-prefixed hexadecimal string
 */
async function requsetToSwitchNetwork(network) {
    if (ethereum == undefined) {
        // throw new Error('MetaMask not installed');
        alert('MetaMask is not installed. Please consider installing it: https://metamask.io/download.html');
        return false;
    }

    try {
        await ethereum.request({
            method: 'wallet_switchEthereumChain',
            params: [{ chainId: network.chainId }],
        });
    } catch (switchError) {
        // This error code indicates that the chain has not been added to MetaMask.
        if (switchError.code === 4902) {
            try {
                await ethereum.request({
                    method: 'wallet_addEthereumChain',
                    params: [network],
                });
            } catch (addError) {
                // handle "add" error
                //   throw new Error('Error when adding network');
                return false;
            }
        } else {
            // handle other "switch" errors
            // throw new Error('Error when switching network');
            return false;
        }
    }
}

/**
 * @param {boolean} valueInNumber 
 * @returns 
 */
async function getCurrentChainId(valueInNumber = true) {
    if (ethereum == undefined) {
        throw new Error('MetaMask not installed');
    }

    const chainIdHex = await ethereum.request({ method: 'eth_chainId' });
    return valueInNumber ? parseInt(chainIdHex) : chainIdHex;
}

async function StartFun() {
    if (await requsetToSwitchNetwork(networks.bsc_testnet) || await getCurrentChainId(false) != networks.bsc_testnet.chainId) {
        unity.SendMessage('GameManager', 'ConnectWalletCancel');
        return;
    }
    await setCollent();
    await setNFT_ABI();
    await getMkpBalance();
}
